import { useQueryState } from 'nuqs';
import { useCallback } from 'react';

export const QUERY_STATE_SELECTED_TICKET_DATA = 'ticket';

const useSelectedTicketQS = () => {
  const [selectedTicket, setSelectedTicket] = useQueryState<string>(QUERY_STATE_SELECTED_TICKET_DATA, {
    defaultValue: '',
    history: 'push',
    parse: (value) => value,
    serialize: (value) => value,
  });

  const handleSelectedTicket = useCallback(
    (ticket: string) => {
      setSelectedTicket(ticket);
    },
    [setSelectedTicket]
  );

  return {
    selectedTicket,
    handleSelectedTicket,
  };
};

export default useSelectedTicketQS;
